(() => {
  'use strict';
  const product = JSON.parse(document.getElementById('sz-product-data')?.textContent || '{}');
  const cfg = JSON.parse(document.getElementById('sz-commerce')?.textContent || '{}');
  const dialog = document.getElementById('sz-cart');
  let busy = false;
  const currency = () => cfg.currency || 'EUR';
  const money = (n) => new Intl.NumberFormat(document.documentElement.lang || 'fr', {style:'currency',currency:currency()}).format(n/100);
  document.querySelectorAll('product-price [ref=priceContainer],.sticky-add-to-cart__price [ref=priceContainer]').forEach(container=>{
    const variant=product.variants?.[0];if(!variant)return;
    const current=container.querySelector('.price bdi'),previous=container.querySelector('.compare-at-price bdi');
    if(current)current.textContent=money(variant.price);if(previous)previous.textContent=money(variant.compare_at_price);
  });
  const escape = s => String(s ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  async function request(url, data) {
    const res = await fetch(url, data ? {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(data)} : {headers:{'Accept':'application/json'},cache:'no-store'});
    const json=await res.json();
    if(!res.ok) throw new Error(json.description || json.message || 'Impossible de mettre à jour le panier. Réessaie.');
    return json;
  }
  const getCart = () => request('/cart.js');
  function renderCart(cart) {
    document.querySelectorAll('.cart-bubble__text-count,[data-sz-count]').forEach(el=>el.textContent=cart.item_count || '');
    document.querySelectorAll('.cart-bubble').forEach(el=>el.hidden=cart.item_count===0);
    if(!dialog)return;
    dialog.querySelector('[data-sz-lines]').innerHTML=cart.items.length ? cart.items.map(item=>`<article class="sz-cart-line"><a href="${escape(item.url)}"><img src="${escape(item.image || '')}" alt="${escape(item.product_title)}"></a><div><h3><a href="${escape(item.url)}">${escape(item.product_title)}</a></h3>${item.variant_title?`<small>${escape(item.variant_title)}</small>`:''}<span class="sz-line-price">${item.final_line_price===0?'Offert':money(item.final_line_price)}</span><div class="sz-line-controls"><button type="button" data-sz-change="${escape(item.key)}" data-quantity="${item.quantity-1}" aria-label="Diminuer ${escape(item.product_title)}">−</button><span>${item.quantity}</span><button type="button" data-sz-change="${escape(item.key)}" data-quantity="${item.quantity+1}" aria-label="Augmenter ${escape(item.product_title)}" ${item.variant_id===cfg.guideVariant?'disabled':''}>+</button><button type="button" data-sz-remove="${escape(item.key)}">Supprimer</button></div></div></article>`).join(''):'<p>Ton panier est vide.</p>';
    dialog.querySelector('[data-sz-total]').textContent=money(cart.total_price);
    dialog.querySelector('.sz-cart-bottom').hidden=!cart.items.length;
  }
  async function refreshCart(open=false){const c=await getCart();renderCart(c);if(open&&!dialog.open)dialog.showModal();return c;}
  async function reconcileGift(cart){
    const gift=cart.items.find(i=>i.variant_id===cfg.guideVariant&&i.properties?._sz_gift==='sellezen');
    if(!gift)return cart;
    const qualifies=cart.items.some(i=>i.variant_id===cfg.mainVariant);
    const wanted=qualifies?1:0;
    return gift.quantity===wanted?cart:request('/cart/change.js',{id:gift.key,quantity:wanted});
  }
  function showError(message,form){
    let el=form?.querySelector('.sz-error');
    if(form&&!el){el=document.createElement('p');el.className='sz-error';el.setAttribute('role','alert');form.append(el);}
    el=el || dialog.querySelector('[data-sz-cart-error]');el.hidden=false;el.textContent=message;
  }
  function syncOffer(){
    const qty=Number(document.querySelector('form[data-sz-product] input[name=quantity]')?.value || document.querySelector('[data-role=val]')?.value || 1);
    const stickyBar=document.querySelector('sticky-add-to-cart');
    if(stickyBar){
      const quantityText=stickyBar.querySelector('[ref=quantityDisplay]');
      if(quantityText)quantityText.style.display=qty>1?'':'none';
      const quantityNumber=stickyBar.querySelector('[ref=quantityNumber]');
      if(quantityNumber)quantityNumber.textContent=qty;
      stickyBar.querySelector('button')?.setAttribute('aria-label','Ajouter au panier');
    }
    const root=document.querySelector('[id^=zroffre]');
    if(!root)return;
    const price=product.variants?.[0]?.price || Number(root.dataset.prix);
    root.querySelector('[data-role=nom]').textContent=`${qty} ${root.dataset.nom} — ${money(price*qty)}`;
    const bump=root.querySelector('[data-role=bump]');
    root.querySelector('[data-role=bump-label]')?.classList.toggle('is-on',Boolean(bump?.checked));
    const bundleTotal=root.querySelector('[data-sz-bundle-total]');
    if(bundleTotal){
      bundleTotal.hidden=!bump?.checked;
      bundleTotal.textContent=`Total de l’offre : ${money(price*qty+Number(cfg.passengerPrice || 0))}`;
    }
  }
  async function add(form){
    if(busy)return;busy=true;
    const button=form.querySelector('[type=submit]');if(button)button.disabled=true;
    form.querySelector('.sz-error')?.remove();
    try{
      const variant=Number(form.querySelector('[name=id]').value);
      const quantity=Math.max(1,Math.min(10,Number(form.querySelector('[name=quantity]')?.value || 1)));
      const items=[{id:variant,quantity}];
      if(cfg.isMain){
        const cart=await getCart();
        if(!cart.items.some(i=>i.variant_id===cfg.guideVariant))items.push({id:cfg.guideVariant,quantity:1,properties:{_sz_gift:'sellezen'}});
        if(document.querySelector('[data-role=bump]')?.checked)items.push({id:cfg.passengerVariant,quantity:1});
      }
      await request('/cart/add.js',{items});
      const cart=await reconcileGift(await getCart());renderCart(cart);
      if(!dialog.open)dialog.showModal();
    }catch(err){showError(err.message,form);}
    finally{busy=false;if(button)button.disabled=false;}
  }
  document.addEventListener('submit',event=>{
    const form=event.target.closest('form[data-sz-product]');
    if(!form)return;event.preventDefault();event.stopImmediatePropagation();add(form);
  },true);
  document.addEventListener('click',async event=>{
    const drawerLink=event.target.closest('header-drawer a[href]');
    if(drawerLink)drawerLink.closest('header-drawer').querySelector('.menu-drawer__close-button')?.click();
    const consentButton=event.target.closest('#shopify-pc__banner__btn-decline,#shopify-pc__banner__btn-accept');
    if(consentButton){
      const accepted=consentButton.id.endsWith('accept');
      const persist=()=>window.Shopify?.customerPrivacy?.setTrackingConsent({analytics:accepted,marketing:accepted,preferences:accepted,sale_of_data:accepted},()=>document.getElementById('shopify-pc__banner')?.remove());
      if(window.Shopify?.customerPrivacy)persist();
      else window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)persist();});
    }
    const cartButton=event.target.closest('[data-testid=cart-drawer-trigger]');
    if(cartButton){event.preventDefault();event.stopImmediatePropagation();refreshCart(true).catch(e=>showError(e.message));return;}
    if(event.target.closest('[data-sz-close]')){dialog.close();return;}
    const change=event.target.closest('[data-sz-change],[data-sz-remove]');
    if(change){
      if(busy)return;busy=true;dialog.setAttribute('aria-busy','true');
      try{const id=change.dataset.szChange || change.dataset.szRemove;const quantity=change.dataset.szRemove?0:Number(change.dataset.quantity);renderCart(await reconcileGift(await request('/cart/change.js',{id,quantity})));}
      catch(e){showError(e.message);}
      finally{busy=false;dialog.removeAttribute('aria-busy');}return;
    }
    if(event.target.closest('sticky-add-to-cart button')){event.preventDefault();event.stopImmediatePropagation();const f=document.querySelector('form[data-sz-product]');if(f)add(f);}
    const localeButton=event.target.closest('[data-sz-locale]');
    if(localeButton){
      event.preventDefault();event.stopImmediatePropagation();
      const panel=document.getElementById(localeButton.getAttribute('aria-controls'));
      panel.hidden=!panel.hidden;localeButton.setAttribute('aria-expanded',String(!panel.hidden));
    }else if(!event.target.closest('[data-sz-localization]')){
      document.querySelectorAll('[data-sz-locale]').forEach(button=>{button.setAttribute('aria-expanded','false');document.getElementById(button.getAttribute('aria-controls')).hidden=true;});
    }
  },true);
  document.addEventListener('keydown',event=>{
    if(event.key!=='Escape')return;
    document.querySelectorAll('[data-sz-locale][aria-expanded=true]').forEach(button=>{button.setAttribute('aria-expanded','false');document.getElementById(button.getAttribute('aria-controls')).hidden=true;button.focus();});
  });
  dialog?.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right)dialog.close();}});
  document.addEventListener('change',e=>{
    if(e.target.matches('[data-sz-variants] input[type=radio]')){
      const picker=e.target.closest('[data-sz-variants]');
      const selected=[...picker.querySelectorAll('input[type=radio]:checked')].map(el=>el.value);
      const variant=product.variants.find(v=>v.options.every((option,i)=>option===selected[i]));
      if(variant){
        document.querySelectorAll('form[data-sz-product] [name=id]').forEach(el=>el.value=variant.id);
        picker.querySelectorAll('input[type=radio]').forEach(el=>el.dataset.currentChecked=el.checked?'true':'false');
        const url=new URL(location.href);url.searchParams.set('variant',variant.id);history.replaceState({},'',url);
      }
    }
    syncOffer();
  },true);
  document.addEventListener('input',syncOffer,true);
  document.addEventListener('click',()=>queueMicrotask(syncOffer));
  const sticky=document.querySelector('sticky-add-to-cart'), form=document.querySelector('form[data-sz-product]');
  if(sticky&&form){
    const updateSticky=()=>{
      const visible=form.getBoundingClientRect().bottom<=0;
      sticky.toggleAttribute('data-sz-sticky-visible',visible);
      sticky.inert=!visible;
      const bar=sticky.querySelector('.sticky-add-to-cart__bar');
      if(bar){bar.dataset.stuck=String(visible);bar.setAttribute('aria-hidden',String(!visible));}
    };
    let pending=false;
    window.addEventListener('scroll',()=>{if(!pending){pending=true;requestAnimationFrame(()=>{pending=false;updateSticky();});}},{passive:true});
    window.addEventListener('resize',updateSticky);
    window.addEventListener('pageshow',updateSticky);
    new IntersectionObserver(updateSticky).observe(form);
    updateSticky();
  }
  const queryVariant=Number(new URLSearchParams(location.search).get('variant'));
  if(queryVariant){const v=product.variants?.find(v=>v.id===queryVariant);if(v){document.querySelectorAll('form[data-sz-product] [name=id]').forEach(e=>e.value=v.id);document.querySelectorAll('[data-sz-variants] input[type=radio]').forEach(e=>{e.checked=v.options.includes(e.value);e.dataset.currentChecked=String(e.checked);});}}
  syncOffer();refreshCart().catch(()=>{});
})();
